<div *ngIf="items && items.length" class="UploadConfirmationDialog">
  <app-table [columns]="tableColumns" [dataSource]="dataSource"></app-table>
</div>
